import React, { useState,useEffect } from 'react';
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import { FormGroup, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid } from '@mui/material';
import Fechadesde from '@mui/material/TextField';
import Fechahasta from '@mui/material/TextField';
import Sucursal from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import theme from "assets/theme";
import Iconpdf from 'assets/pdf/iconpdf';
import { Page, Text, View, Document, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import { useMaterialUIController } from "context";
import { Check, CheckBox, WindowSharp } from '@mui/icons-material';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import {TextField} from '@mui/material';
import ReporteRecepcionMatricula from "components/ReporteRecepcionMatricula";
import PDFModal from "components/PDFModal";
import jsPDF from 'jspdf';
import Checkbox from '@mui/material/Checkbox';
import { FormControlLabel } from '@mui/material';
import { useApi } from "lib/api";

export default function EntregaMatriculas() {
  var tcosto = 0.00
  var tvalor = 0.00

  const[fecha1,setFecha1] = useState("")
  const[fecha2,setFecha2] = useState("")
  const[nosucursal,setNosucursal] = useState("")
  const[rowsdata,setRowsdata] = useState([])
  const[rowsdata2,setRowsdata2] = useState([])
  const[rowsdata3,setRowsdata3] = useState([])
  const[opendialog,setOpendialog] = useState(false)
  const[mensaje,setMensaje] = useState("")
  const[mostrarMensaje,setMostrarMensaje] = useState(false)

  
  const opcionstatus = ['T=Todos','I=Incautados','V=Vendido', 'N=Normal']
  const[status,setStatus] = useState(opcionstatus[0])
  const[sucursalnueva,setSucursalnueva] = useState("")
  const[sucursalactual1,setSucursalactual1] = useState("")
  const[chasis,setChasis] = useState("")
  const[listasucursales,setListasucursales] = useState([])
  const { breakpoints,typography } = theme;
  const drawerWidth = 240
  const [detalleMatri,setDetalleMatri] = useState([])
  const [detalleRows2,setDetalleRows2] = useState([])
  
  const [abrirpdf,setAbrirpdf] = useState(false)
  const[sucursal,setSucursal] = useState([])
  
  // Estados para el formulario de entrega
  const[nombresCliente,setNombresCliente] = useState("")
  const[apellidosCliente,setApellidosCliente] = useState("")
  const[cedulaCliente,setCedulaCliente] = useState("")
  const[fechaEntrega,setFechaEntrega] = useState("")
  const[sucursalEntrega,setSucursalEntrega] = useState("")
  const[mostrarFormulario,setMostrarFormulario] = useState(false)
  const[tipoDocumento,setTipoDocumento] = useState("matricula")
  const[documentosSeleccionados,setDocumentosSeleccionados] = useState([])
  const[documentosEntregar,setDocumentosEntregar] = useState([])
  const[documentosEntregados,setDocumentosEntregados] = useState("")
  const[documentosDisponibles,setDocumentosDisponibles] = useState([])
  const[nuevoDoc,setNuevoDoc] = useState([])
  
  
  // Función para manejar cambios en los checkboxes
  const handleStatusEntrega = (index, checked, documentos) => {
    const updatedDocumentos = documentosEntregar.map((item, i) => 
      item.documento === documentos ? { ...item, entregado: checked } : item
    );
    setDocumentosEntregar(updatedDocumentos)
    
    const updatedDocumentosDisponibles = documentosDisponibles.map((item, i) => 
      i === index ? { ...item, entregado: checked } : item
    );
    setDocumentosDisponibles(updatedDocumentosDisponibles)
    


    if (checked == true){
      let nuevodoc = [...nuevoDoc, documentos]
      setNuevoDoc(nuevodoc)
      agregarDocumentoSeleccionado(chasis,nuevodoc)
      
    }
    
    if (checked == false){
      
      const documentosdesmarcados = nuevoDoc.filter(item => item != documentos)
      setNuevoDoc(documentosdesmarcados)

      const documentosselecc2 = documentosSeleccionados.map(item => {
        let nuevoselecc = item.tipo.filter(item => item != documentos)
        return {
          ...item,
          tipo: nuevoselecc
        }
      })
      
      setDocumentosSeleccionados(documentosselecc2)
    }
  }
  
  // Estados para el modal de PDF
  const[mostrarPDFModal,setMostrarPDFModal] = useState(false)
  const[pdfUrl,setPdfUrl] = useState("")
    
  
  const [presentarpdf,setPresentarpdf] = useState(false)

  const[controller] = useMaterialUIController()
  const {nombreNegocio,roleWeb} = controller
  const { post } = useApi()



  useEffect(() => {
    post('/api/consultarmatricula')
    .then(function({ status, data }){
      if (status === 200) {
            //rows = [data["facturacion"]]
            setRowsdata(data["matriculas"])
            setRowsdata2(data["matriculas2"])
            setRowsdata3(data["pagomatri"])
            setListasucursales(data["sucursales"])

      }
      if (status === 400) {
//            alert(data["Error"])

      }})
  },[]);

  function handlechasis(valor){
    setChasis(valor)

    if(typeof valor == "string"){
      setDetalleMatri(rowsdata3.filter(value => value.chasis==valor))
      setDetalleRows2(rowsdata2.find(value => value.chasis==valor))
      
      //agrupar documentos a entregar
      const rows = [rowsdata2.find(value => value.chasis==valor)]
      
      let json_str = rows[0]?.sucursaldocumentos ? JSON.parse(rows[0].sucursaldocumentos).documentos : null
      console.log(json_str) 
    
      if (rows[0]){
        console.log("1am",rows)
        if (rows[0].sucursaldocumentos){
           json_str = rows[0].sucursaldocumentos.includes("*") ? JSON.parse(rows[0].sucursaldocumentos).documentos.split("*") : [JSON.parse(rows[0].sucursaldocumentos).documentos]
        } else {
          json_str = null
        }
        
        console.log("1am",json_str)
      } else {
        json_str = null
      }


      if(json_str){
        const arrayjsonnoentregados = []
        let docEntregados= ""
        let docDisponibles = []
         json_str.map((item,i) => {
           let item1 = JSON.parse(item)
           if (item1.sucursalrecep.split("-")[0]==localStorage.getItem("sucursal").split("-")[0]){//validar si la sucursal es la misma que la sucursal de entrega
             let parsedItem = JSON.parse(item)
             arrayjsonnoentregados.push(parsedItem)
             if (item1.entregado == true){
               docEntregados = docEntregados + item1.documento + "*"
             }
             if (item1.entregado == false){
                docDisponibles.push(parsedItem)
             }
           }
         })
        setDocumentosEntregar(arrayjsonnoentregados)
        setDocumentosEntregados(docEntregados)
        setDocumentosDisponibles(docDisponibles)
      } else {
        setDocumentosEntregados("")
        setDocumentosDisponibles([])

      }
      
    }

  }

  
  function agregarDocumentoSeleccionado(chasisValue, tipoDoc){
    if(chasisValue){
      // Obtener detalles del chasis seleccionado
      const detalle = rowsdata2.find(value => value.chasis === chasisValue)
      const pagos = rowsdata3.filter(value => value.chasis === chasisValue)
      

      const detalledocumentos1 = JSON.parse(detalle.sucursaldocumentos).documentos.split("*")
      
      const arraydetalledocumentos = []
      detalledocumentos1.map((item,i) => {
        arraydetalledocumentos.push(JSON.parse(item))
      })

      if(detalle){
        const nuevoDocumento = [{
          chasis: chasisValue,
          tipo: tipoDoc,
          detalledocumentos: arraydetalledocumentos,
          detalledelaentrega: [],
          pagos: pagos,
          id: `${chasisValue}_${tipoDoc}_${Date.now()}`
        }]
        setDocumentosSeleccionados(nuevoDocumento)
        console.log("manuel",nuevoDocumento)
      }
    }
  }

  
  
  
  function procesarEntrega(){
    let aerror = false
    
    
    if (aerror == false){
      console.log("documentosEntregar",documentosEntregar)
      for (let i = 0; i < documentosEntregar.length; i++) {
        
        if (documentosEntregar[i].sucursalrecep.split("-")[0] != sucursalEntrega.label.split("-")[0]){
          setMensaje("Alguno de los documentos a entregar no pertenece a esta sucursal, la "+documentosEntregar[i].documento
            +" esta en la sucursal "+documentosEntregar[i].sucursalrecep.split("-")[1])
          setMostrarMensaje(true)
          aerror = true
          break
          
        }
      }
    } 

    if (aerror == false){
      ///convertir array de documentos a string a json para enviar al backend
      let jsonstring = ""
      documentosEntregar.map(item => (
          jsonstring = jsonstring + JSON.stringify(item) + "*"
      ))
      
      let str = jsonstring.lastIndexOf("*")
      if (str != -1){
        jsonstring = jsonstring.slice(0,str)
      }
      
      const jsonstring2 = {"documentos":jsonstring}
      
      
      const strincliente = {
        "nombres":nombresCliente,
        "apellidos":apellidosCliente,
        "cedula":cedulaCliente,
        "fecha":fechaEntrega,
        "sucursalentrega":sucursalEntrega.label,
        "chasis":chasis,
        "sucursalentrega":sucursalEntrega.label,
        "cajero":localStorage.getItem('usuario'),
        "documentoentregado":documentosSeleccionados[0].tipo.join(),
      } 
      
      let clienterecepcion = ""
      if (detalleRows2['cajeromatriculaentregada']) {
         const jsoncajero = detalleRows2['cajeromatriculaentregada']
         clienterecepcion = jsoncajero+"*"+JSON.stringify(strincliente)
      } else {
        clienterecepcion = JSON.stringify(strincliente)
      }

      post('/api/transferenciabackend_procesarentrega', {
        'documentos':jsonstring2,
        'datosdelaentrega':clienterecepcion,
        'sucursal':strincliente['sucursalentrega'],
        'nombres':strincliente['nombres'],
        'apellidos':strincliente['apellidos'],
        'cedula':strincliente['cedula'],
        'fecha':strincliente['fecha'],
        'chasis':strincliente['chasis'],
        'sucursalentrega':strincliente['sucursalentrega'],
        'multiple': documentosSeleccionados.length > 0
      })
      .then(function({ status, data }){
        if (status === 200) {

              const detalle = [detalleRows2].map(data => {
                return {
                  ...data,
                  detalledelaentrega: strincliente,
                  documentosparaentrega: nuevoDoc,
                  detallepagos: detalleMatri,
                }
              })

              setDetalleRows2(detalle)
              

              
              let jsonstring = JSON.stringify(jsonstring2)
              const updatedRows = rowsdata2.map((item, i) => 
                item.chasis === strincliente['chasis'] ? { 
                  ...item, sucursaldocumentos: jsonstring, cajeromatriculaentregada: clienterecepcion } : item
              );
              setRowsdata2(updatedRows)

      
              setMensaje(`Se entregaron correctamente ${nuevoDoc.length} documento(s)`)
              setMostrarMensaje(true)
              generarReporteRecepcion(detalle)
              // Limpiar datos
              setDetalleMatri([])
              setChasis("")
              setDocumentosSeleccionados([])
              setNuevoDoc([])

        }
        if (status === 400) {
              setMensaje(data["Error"])
              setMostrarMensaje(true)
              setDetalleMatri([{}])
        }})
    }

    if (aerror == false){
      setMostrarFormulario(false)
      // Limpiar formulario
      setNombresCliente("")
      setApellidosCliente("")
      setCedulaCliente("")
      setFechaEntrega("")
      setSucursalEntrega("")
    }
  }

  
  function cancelarEntrega(){
    // Limpiar formulario
    setNombresCliente("")
    setApellidosCliente("")
    setCedulaCliente("")
    setFechaEntrega("")
    setSucursalEntrega("")
    setMostrarFormulario(false)
  }

  
  function abrirFormularioEntrega(){
    let aerror = false
    
    if(aerror == false){
      if(detalleMatri[0]?.endoso.length == 0 || detalleMatri[0]?.placa.length == 0){
        setMensaje("Por favor seleccione un chasis con datos de placa y endoso correctamente definidos contacte al departamento de placas y matriculas")
        setMostrarMensaje(true)
        return
      }
    }

    if(aerror == false){
      if(chasis !== "" || documentosSeleccionados.length > 0){
        setMostrarFormulario(true)
      }
    }
    if (aerror == true){
      setMensaje("Por favor seleccione un chasis con datos de entrega primero")
      setMostrarMensaje(true)
    }
  }

  function generarReporteRecepcion(detalle){
    if(documentosSeleccionados.length > 0){
      // Generar reporte para múltiples documentos
      
      const documentosParaReporte = detalle.map(doc => ({
        chasis: doc.chasis,
        tipo: doc.tipo,
        nombres: doc.detalledelaentrega['nombres'] || '',
        apellidos: doc.detalledelaentrega['apellidos'] || '',
        cedula: doc.detalledelaentrega['cedula'] || '',
        fecha: doc.detalledelaentrega['fecha'] || '',
        sucursal: doc.detalledelaentrega['sucursalentrega'] || '',
        cajero: localStorage.getItem('usuario') || '',
        localizacion: doc.detalledelaentrega['sucursalentrega'] || '',
        documentosparaentrega: doc.documentosparaentrega,
        pagos: doc.detallepagos
      }));
      
      // Preparar datos de pago si existen
      let datosPago = null;
      if(detalleMatri && detalleMatri.length > 0){
        const pago = detalleMatri[0]; // Tomar el primer pago
        datosPago = {
          valor: pago.valor || '',
          fecha: pago.fecha || '',
          recibido: pago.recibido || '',
          descripcion: pago.descripcion || ''
        }
      }

      // Generar PDF para múltiples documentos
      const url = ReporteRecepcionMatricula.generarPDFMultiple(documentosParaReporte);
      setPdfUrl(url);
      setMostrarPDFModal(true);
    } else if(chasis && chasis !== "" && detalleRows2){
      // Preparar datos de la matrícula individual
      const datosMatricula = {
        chasis: chasis,
        nombres: detalle['detalledelaentrega']['nombre'] || '',
        apellidos: detalleRows2['detalledelaentrega']['apellidos'] || '',
        cedula: detalleRows2['detalledelaentrega']['cedula'] || '',
        fecha: detalleRows2['detalledelaentrega']['fecha'] || '',
        sucursal: detalleRows2['detalledelaentrega']['sucursal'] || '',
        cajero: localStorage.getItem('usuario') || '',
        localizacion: detalleRows2['detalledelaentrega']['sucursalentrega'] || ''
      }

      // Preparar datos de pago si existen
      let datosPago = null;
      if(detalleMatri && detalleMatri.length > 0){
        const pago = detalleMatri[0]; // Tomar el primer pago
        datosPago = {
          valor: pago.valor || '',
          fecha: pago.fecha || '',
          recibido: pago.recibido || '',
          descripcion: pago.descripcion || ''
        }
      }

      // Generar PDF y mostrar en modal
      const url = ReporteRecepcionMatricula.generarPDFMultiple(datosMatricula, datosPago);
      setPdfUrl(url);
      setMostrarPDFModal(true);
    } else {
      setMensaje("Por favor seleccione un chasis con datos de entrega primero")
      setMostrarMensaje(true)
    }
  }

  function cerrarPDFModal(){
    setMostrarPDFModal(false);
    // Limpiar la URL para liberar memoria
    if(pdfUrl){
      URL.revokeObjectURL(pdfUrl);
      setPdfUrl("");
    }
  }

  

    return(
     
     <Box component="main" > 
        <Grid container >
              <Grid item xs={12} md={12} lg={12} marginLeft={'20px'}>
                <Typography variant="h4" fontWeight={"bold"} >{"Buscar Chasis"}</Typography>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Autocomplete
                    style={{marginTop:"15px",marginLeft:"20px",width:"35%"}}
                    variant = "standard"    
                    disablePortal
                    id="combo-box-demo"
                    options={rowsdata}
                    value = {chasis}
                    onInputChange={(event,newValue)=>{handlechasis(newValue);}}
                    onChange={(event,newValue)=>{handlechasis(newValue);}}
                    onBlur={(event) => handlechasis(event.target.value)}
                    renderInput={(params) => 
                      <TextField {...params}  
                        label="Busqueda" 
                        slotProps={{
                        input: {
                          ...params.InputProps,
                          type: 'search',
                        },
                      }}/>}                    
                  />
              </Grid>

              {/* Sección para agregar documentos */}
              {chasis && (
                <Grid item xs={12} md={12} lg={12} style={{marginTop: 20, marginLeft: 20}}>
                  <Box style={{ backgroundColor: documentosDisponibles.length != 0 ? '#f5f5f5' : '', padding: 15, borderRadius: 5}}>
                     {documentosEntregados.length != 0 ?
                      <Typography variant="h6" style={{marginBottom: 10}}>
                        <Grid style={{color: "red",fontSize: "22px"}} item xs={2} md={2} lg={2} >{"Entregados: ["+documentosEntregados+"]"}</Grid>   
                      </Typography>
                     :''}

                     <Grid container spacing={1}>
                       {documentosDisponibles.map((item, index) => ( 
                         <>
                         <Grid item xs={2} md={2} lg={2} key={index}>
                           <FormGroup>
                            <FormControlLabel 
                              control={
                                 <Checkbox
                                   checked={item.entregado || false}
                                   onChange={(e) => handleStatusEntrega(index, e.target.checked, item.documento)}
                                />
                              } 
                              label={item.documento}
                              sx={{"& .MuiFormControlLabel-label": {fontSize: "22px"}}}
                            />
                            
                           </FormGroup>
                         </Grid>
                         
                         </>
                       ))}
                     </Grid>
                    
                  </Box>
                </Grid>
              )}

              {/* Lista de documentos seleccionados */}
              {documentosSeleccionados.length > 0 && (
                <Grid item xs={12} md={12} lg={12} style={{marginTop: 20, marginLeft: 20}}>
                  {nuevoDoc.length > 0 ? 
                    
                  <Box style={{backgroundColor: '#e3f2fd', padding: 15, borderRadius: 5}}>
                    <Typography variant="h6" style={{marginBottom: 10}}>
                      Documentos Seleccionados ({nuevoDoc.length})
                    </Typography>
                  
                    {documentosSeleccionados.map((doc, index) => ( doc.tipo.map((tipo, index) => (    
                      <Box key={doc.id} style={{
                        backgroundColor: 'white',
                        padding: 10,
                        margin: '5px 0',
                        borderRadius: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <Typography variant="body2">
                          <strong>Chasis:</strong> <strong style={{fontWeight:"bold",color:"green"}}>{doc.chasis}</strong> | <strong>Tipo:</strong> <strong style={{fontWeight:"bold",color:"green"}}>{tipo}</strong> 
                        </Typography>
                        
                      </Box>
                    ))))}
                  </Box>
                  :''}
                </Grid>
              )}
              
              {detalleMatri.map((item,i) => (
              <Grid item xs={12} md={3} lg={3}>
              
                <Box width={450} height={300} borderRadius={3} boxShadow={5} style={{backgroundColor:'white',padding:20, marginTop:20, marginLeft:20}} >
                    
                    <Grid container>
                        <Grid item lg={12} style={{backgroundColor:"white"}}>
                            <h3>Detalle Pagos</h3>
                        </Grid>          

                        <Grid item lg={6} marginTop={2}>
                            <p style={{fontWeight:"bold",fontSize:14}}>Nombre:</p>
                        </Grid>  
                        <Grid item lg={6} marginTop={2}>
                            <p style={{fontSize:14}}>{item==undefined?"-":item.nombres}</p>
                        </Grid>  
                        <Grid item lg={6} >
                            <p style={{fontWeight:"bold",fontSize:14}}>Apellido:</p>
                        </Grid>  
                        <Grid item lg={6}>
                            <p style={{fontSize:14}}>{item==undefined?"-":item.apellidos}</p>
                        </Grid>  
                        <Grid item lg={6}>
                            <p style={{fontWeight:"bold",fontSize:14}}>Pagado:</p>
                        </Grid>  
                        <Grid item lg={6}>
                            <p style={{fontSize:14}}>{item==undefined?"-":item.valor}</p>
                        </Grid>
                        <Grid item lg={6}>
                            <p style={{fontWeight:"bold",fontSize:14}}>Fecha:</p>
                        </Grid>  
                        <Grid item lg={6}>
                            <p style={{fontSize:14}}>{item==undefined?"-":item.fecha}</p>
                        </Grid>
                        
                        <Grid item lg={6}>
                            <p style={{fontWeight:"bold",fontSize:14}}>Recibido:</p>
                        </Grid>  
                        <Grid item lg={6}>
                            <p style={{fontSize:14}}>{item==undefined?"-":item.recibido}</p>
                        </Grid>
                        
                        <Grid item lg={6}>
                            <p style={{fontWeight:"bold",fontSize:14}}>Endoso:</p>
                        </Grid>  
                        <Grid item lg={6}>
                            <p style={{fontSize:14}}>{item==undefined?"-":item.endoso}</p>
                        </Grid>
                        
                        <Grid item lg={6}>
                            <p style={{fontWeight:"bold",fontSize:14}}>Placa:</p>
                        </Grid>  
                        <Grid item lg={6}>
                            <p style={{fontSize:14}}>{item==undefined?"-":item.placa}</p>
                        </Grid>

                        
                        
                    </Grid>
                </Box>
              
              </Grid>
              ))}
              
              
              <Grid item xs={12} md={12} lg={12}>
                {/* Botón para abrir formulario de entrega */}
                {(chasis!="" && detalleMatri.length!=0 && detalleMatri[0].nombrematriculaentregada.length === 0) || documentosSeleccionados.length > 0 ?
                    <Box style={{marginTop:20, marginLeft:20}}>
                        <Button 
                        variant="contained" 
                        disabled={nuevoDoc.length > 0 ? false : true}
                        onClick={abrirFormularioEntrega}
                        style={{marginRight:10,color: 'white'}}
                        >
                        {documentosSeleccionados.length > 0 ? `Entregar ${nuevoDoc.length} Documento(s)` : "Entregar Matrícula"}
                        </Button>
                    </Box>
                :''}
              </Grid>
        </Grid>

        {/* Dialog para formulario de entrega */}
        {detalleRows2 && detalleRows2['inventario'] === "S" ?
          <Dialog 
            open={mostrarFormulario} 
            onClose={() => setMostrarFormulario(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              <Typography variant="h5" fontWeight="bold">
                {documentosSeleccionados.length > 0 ? 
                  `Formulario de Entrega de ${documentosSeleccionados.length} Documento(s)` : 
                  "Formulario de Entrega de Matrícula"
                }
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={3} style={{marginTop: 10}}>
                {/* Información de los documentos seleccionados */}
                <Grid item xs={12}>
                  <Typography variant="h6" style={{marginBottom: 10}}>
                    {documentosSeleccionados.length > 0 ? 
                      `Documentos a Entregar (${documentosSeleccionados.length}):` : 
                      `Chasis Seleccionado: ${chasis}`
                    }
                  </Typography>
                  {documentosSeleccionados.length > 0 && (
                    <Box style={{backgroundColor: '#f5f5f5', padding: 10, borderRadius: 5, marginBottom: 10}}>
                      {documentosSeleccionados.map((doc, index) => (
                        <Typography key={doc.id} variant="body2" style={{marginBottom: 5}}>
                          • Chasis: {doc.chasis} | Tipo: {doc.tipo} 
                        </Typography>
                      ))}
                    </Box>
                  )}
                </Grid>

                {/* Nombres del cliente */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Nombres del Cliente"
                    value={nombresCliente}
                    onChange={(e) => setNombresCliente(e.target.value)}
                    variant="outlined"
                    required
                  />
                </Grid>

                {/* Apellidos del cliente */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Apellidos del Cliente"
                    value={apellidosCliente}
                    onChange={(e) => setApellidosCliente(e.target.value)}
                    variant="outlined"
                    required
                  />
                </Grid>

                {/* Cédula del cliente */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Cédula del Cliente"
                    value={cedulaCliente}
                    onChange={(e) => setCedulaCliente(e.target.value)}
                    variant="outlined"
                    required
                    type="text"
                  />
                </Grid>

                {/* Fecha de entrega */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Fecha de Entrega"
                    value={fechaEntrega}
                    onChange={(e) => setFechaEntrega(e.target.value)}
                    variant="outlined"
                    type="date"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                {/* Sucursal */}
                <Grid item xs={12}>
                  <Autocomplete
                    fullWidth
                    options={listasucursales}
                    value={sucursalEntrega}
                    onChange={(event, newValue) => setSucursalEntrega(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Sucursal de Entrega"
                        variant="outlined"
                        required
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                style = {{color:"white"}}
                onClick={cancelarEntrega}
                
              >
                Cancelar
              </Button>
              <Button 
                onClick={procesarEntrega}
                variant="contained"
                style = {{color:"white"}}
                disabled={!nombresCliente || !apellidosCliente || !cedulaCliente || !fechaEntrega || !sucursalEntrega}
              >
                Procesar Entrega
              </Button>
            </DialogActions>
          </Dialog>
        : (
          <Dialog
          open={mostrarFormulario} 
          onClose={() => setMostrarFormulario(false)}
          maxWidth="md"
          fullWidth
          >
            <DialogTitle>
              <Typography variant="h5" fontWeight="bold" style={{color:"red"}}>
                Matrícula no ha sido recibida, aunque se encuentra pagada por el cliente.  No es posible entregarla
              </Typography>
            </DialogTitle>
          </Dialog>
        )}

        {/* Dialog para mostrar mensaje */}
        <Dialog
          open={mostrarMensaje}
          onClose={() => setMostrarMensaje(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              Información
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              {mensaje}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => setMostrarMensaje(false)}
              style={{color: 'white'}}
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal para mostrar PDF */}
        <PDFModal
          open={mostrarPDFModal}
          onClose={cerrarPDFModal}
          pdfUrl={pdfUrl}
          title={documentosSeleccionados.length > 0 ? 
            `Reporte de Recepción de ${documentosSeleccionados.length} Documento(s)` : 
            "Reporte de Recepción de Matrícula"
          }
          showDownloadButton={true}
          showPrintButton={true}
        />
        
     </Box>

    );    
}

